export interface ToastProvider {
  success: (title: string, message: string) => void;
  warning: (title: string, message: string) => void;
  error: (title: string, message: string) => void;
}
